import { useQuery } from "@apollo/client";
import { GET_BATCH_UPLOAD_FORMATS } from "api/Import/CustomImport/queries";
import {
  GetBatchUploadFormats,
  GetBatchUploadFormats_batchUploadFormats,
  GetBatchUploadFormatsVariables,
} from "api/Import/CustomImport/types/GetBatchUploadFormats";
import { getBUFromLocalStorage } from "helpers/storage";

export const useGetBatchUploadFormats = () => {
  const { data, ...rest } = useQuery<GetBatchUploadFormats, GetBatchUploadFormatsVariables>(GET_BATCH_UPLOAD_FORMATS, {
    variables: {
      businessUnitId: getBUFromLocalStorage(),
    },
    fetchPolicy: "cache-and-network",
  });

  const breeds = (data?.batchUploadFormats || []) as GetBatchUploadFormats_batchUploadFormats[];

  return {
    data: breeds,
    ...rest,
  };
};
